import api from './api';

export const announcementsService = {
  // Pobierz listę użytkowników do wyboru odbiorców
  getUsers: async () => {
    const response = await api.get('/announcements/users');
    return response.data;
  },

  // Pobierz wszystkie ogłoszenia
  getAnnouncements: async (year) => {
    const params = year ? { year } : {};
    const response = await api.get('/announcements', { params });
    return response.data;
  },

  // Pobierz szczegóły ogłoszenia
  getAnnouncement: async (id) => {
    const response = await api.get(`/announcements/${id}`);
    return response.data;
  },

  // Dodaj komentarz do ogłoszenia
  addComment: async (announcementId, text) => {
    const response = await api.post(`/announcements/${announcementId}/comments`, { text });
    return response.data;
  },

  // Utwórz nowe ogłoszenie
  createAnnouncement: async (announcementData) => {
    const formData = new FormData();
    
    formData.append('title', announcementData.title);
    formData.append('content', announcementData.content);
    formData.append('type', announcementData.type || 'informacja');
    if (announcementData.eventDate) {
      formData.append('eventDate', announcementData.eventDate);
    }
    formData.append('isImportant', announcementData.isImportant || false);
    formData.append('isForAll', announcementData.isForAll !== undefined ? announcementData.isForAll : true);
    if (!announcementData.isForAll && announcementData.targetUsers && announcementData.targetUsers.length > 0) {
      formData.append('targetUsers', JSON.stringify(announcementData.targetUsers));
    }

    // Dodaj załączniki
    if (announcementData.attachments && announcementData.attachments.length > 0) {
      announcementData.attachments.forEach(file => {
        formData.append('attachments', file);
      });
    }

    // Dodaj tło ogłoszenia
    if (announcementData.holidayBackground) {
      formData.append('holidayBackground', announcementData.holidayBackground);
    }

    // Dodaj kolorowanki
    if (announcementData.coloringPages && announcementData.coloringPages.length > 0) {
      announcementData.coloringPages.forEach(file => {
        formData.append('coloringPages', file);
      });
    }

    const response = await api.post('/announcements', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Aktualizuj ogłoszenie
  updateAnnouncement: async (id, announcementData) => {
    const formData = new FormData();
    
    if (announcementData.title) formData.append('title', announcementData.title);
    if (announcementData.content) formData.append('content', announcementData.content);
    if (announcementData.type) formData.append('type', announcementData.type);
    if (announcementData.eventDate !== undefined) {
      formData.append('eventDate', announcementData.eventDate || '');
    }
    if (announcementData.isImportant !== undefined) {
      formData.append('isImportant', announcementData.isImportant);
    }
    if (announcementData.isForAll !== undefined) {
      formData.append('isForAll', announcementData.isForAll);
    }
    if (announcementData.targetUsers !== undefined) {
      if (!announcementData.isForAll && announcementData.targetUsers.length > 0) {
        formData.append('targetUsers', JSON.stringify(announcementData.targetUsers));
      }
    }

    // Dodaj nowe załączniki
    if (announcementData.newAttachments && announcementData.newAttachments.length > 0) {
      announcementData.newAttachments.forEach(file => {
        formData.append('attachments', file);
      });
    }

    // Usuń załączniki
    if (announcementData.removeAttachments && announcementData.removeAttachments.length > 0) {
      announcementData.removeAttachments.forEach(index => {
        formData.append('removeAttachments', index);
      });
    }

    // Dodaj nowe tło ogłoszenia
    if (announcementData.holidayBackground) {
      formData.append('holidayBackground', announcementData.holidayBackground);
    }

    // Usuń tło ogłoszenia
    if (announcementData.removeHolidayBackground) {
      formData.append('removeHolidayBackground', 'true');
    }

    // Dodaj nowe kolorowanki
    if (announcementData.newColoringPages && announcementData.newColoringPages.length > 0) {
      announcementData.newColoringPages.forEach(file => {
        formData.append('coloringPages', file);
      });
    }

    // Usuń kolorowanki
    if (announcementData.removeColoringPages && announcementData.removeColoringPages.length > 0) {
      announcementData.removeColoringPages.forEach(index => {
        formData.append('removeColoringPages', index);
      });
    }

    const response = await api.put(`/announcements/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Usuń ogłoszenie
  deleteAnnouncement: async (id) => {
    const response = await api.delete(`/announcements/${id}`);
    return response.data;
  },

  // Oznacz jako przeczytane
  markAsRead: async (id) => {
    const response = await api.post(`/announcements/${id}/read`);
    return response.data;
  },

  // Potwierdź zapoznanie się
  confirmRead: async (id) => {
    const response = await api.post(`/announcements/${id}/confirm`);
    return response.data;
  },

  // Pobierz załącznik
  getAttachment: async (announcementId, attachmentIndex) => {
    const response = await api.get(`/announcements/${announcementId}/attachment/${attachmentIndex}`, {
      responseType: 'blob'
    });
    return response.data;
  },

  // Pobierz listę użytkowników, którzy potwierdzili przeczytanie
  getConfirmations: async (announcementId) => {
    const response = await api.get(`/announcements/${announcementId}/confirmations`);
    return response.data; // response.data zawiera już { success, confirmedUsers, notConfirmedUsers, stats }
  }
};

